import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { IPermissionUser } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class PermissionUserService extends BaseService<IPermissionUser> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'permissionUser');
  }

  reset(locationId: number, userId: number): Observable<number> {
    return this.http.post<number>(
      this.baseUrl + 'reset',
      { user_id: userId, location_id: locationId },
      this.defaultOptions
    );
  }
}

export { IPermissionUser } from '../shared/api';
